import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import styles from './modalContent.module.scss';
import { ModalContentProps } from './types';
export function ModalContent(t0) {
  const $ = _c(10);
  const {
    size: t1,
    children,
    className,
    maxHeight,
    maxWidth
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = [styles.content, className].filter(Boolean);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[2] !== maxHeight || $[3] !== maxWidth) {
    t4 = {
      maxHeight,
      maxWidth
    };
    $[2] = maxHeight;
    $[3] = maxWidth;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== size || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3} data-size={size} style={t4}>{children}</div>;
    $[5] = children;
    $[6] = size;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
ModalContent.displayName = 'ModalContent';